import type { PlanTaskDetail } from './planTypes';

export enum TaskKind {
  productionPlan = 'productionPlan',
  videoReview = 'videoReview'
}

export type VideoReviewSummary = {
  jobId: string;
  camera: string;
  room?: string | null;
  peopleCount: number;
  newAnswerFromYourNotes: boolean;
};

export type TodayProgress = { done: number; goal: number; kitchenChecked: number };

export const goalMet = (progress: TodayProgress | undefined): progress is TodayProgress =>
  progress !== undefined && progress.done >= progress.goal;

export type Task = {
  id: string;
  kind: TaskKind;
  title: string;
  startsAt: string;
  endsAt?: string | null;
  doneAt?: string | null;
  productionPlan?: PlanTaskDetail | null;
  videoReview?: VideoReviewSummary | null;
};

// Sent as clientVersion; raised when what the client measures changes.
export const VIDEO_REVIEW_CLIENT_VERSION = 1;

export type VideoReviewSegment = { action: string; startMs: number; endMs: number; reason?: string | null };

export type VideoReviewPerson = {
  segments: VideoReviewSegment[];
  durationMs: number;
  pastWords: string[];
  rounds: number;
  canGiveWords: boolean;
};

export type VideoReviewLimits = { maxNoteChars: number; maxNoteAudioSeconds: number };

export type VideoReview = {
  id: string;
  digest: string;
  camera: string;
  room?: string | null;
  recordedAt: string;
  people: VideoReviewPerson[];
  maxRevisions: number;
  limits: VideoReviewLimits;
};

export enum VideoReviewAnswer {
  CONFIRMED = 'CONFIRMED',
  WRONG = 'WRONG',
  CANT_TELL = 'CANT_TELL'
}

export enum VideoReviewReason {
  WRONG_ACTION = 'WRONG_ACTION',
  WRONG_TIME = 'WRONG_TIME',
  WRONG_PERSON = 'WRONG_PERSON',
  NOT_IN_LIST = 'NOT_IN_LIST'
}

export enum VideoReviewSkipReason {
  WONT_PLAY = 'WONT_PLAY',
  CANT_SEE = 'CANT_SEE',
  OTHER = 'OTHER'
}

export enum VideoReviewEventType {
  OPEN = 'OPEN',
  START = 'START',
  BAIL = 'BAIL'
}
